import { FC, MouseEvent } from 'react'
import { useLoginGuardAction } from '@wellesley/auth'

import { THeader } from '../types'

import Divider from './Divider'
import TimeLabel from './TimeLabel'
import EditedLabel from './EditedLabel'
import PinnedLabel from './PinnedLabel'
import PrivacyLabel from './PrivacyLabel'

const HeaderControls: FC<THeader> = ({
  feed,
  time,
  renderMenu,
  showPrivacy = true,
  privacyOptionsVariant,
}) => {
  const guardedAction = useLoginGuardAction()
  const handleMenuClick = (evt: MouseEvent<HTMLDivElement>) => {
    guardedAction()
    evt.preventDefault()
  }

  const isReplyFeed = feed.path.length > 0

  return (
    <div className="flex max-h-[18px] items-center justify-end gap-2">
      <div className="flex h-full items-center text-sm font-medium text-gray-600">
        {feed.pinned && (
          <>
            <PinnedLabel isReplyFeed={isReplyFeed} />
            <Divider />
          </>
        )}
        {showPrivacy && (
          <div className="flex items-center" data-testid="header-privacy-tag">
            <PrivacyLabel
              feed={feed}
              privacyOptionsVariant={privacyOptionsVariant}
            />
            <Divider />
          </div>
        )}
        {feed.edited && (
          <div className="hidden items-center md:flex">
            <EditedLabel feed={feed} />
            <Divider />
          </div>
        )}
        {time && <TimeLabel {...{ feed, time, renderMenu }} />}
      </div>
      {renderMenu && (
        <div
          data-testid="header-menu-trigger"
          onClick={handleMenuClick}
          className="z-2 relative grid min-w-6 cursor-pointer place-content-center"
        >
          {renderMenu()}
        </div>
      )}
    </div>
  )
}

export default HeaderControls
